const STEPS = [
  {
    n: "01",
    title: "Faça sua aplicação",
    description: "Formulário rápido com o seu perfil profissional.",
  },
  {
    n: "02",
    title: "Análise da nossa equipe",
    description: "Curadoria manual, caso a caso.",
  },
  {
    n: "03",
    title: "Aprovação",
    description:
      "Se aprovado, entramos em contato pelo telefone para alinhar os próximos passos.",
  },
  {
    n: "04",
    title: "Comece a divulgar",
    description:
      "Onboarding, treinamento e material para levar o produto aos seus clientes.",
  },
];

export const EventoComoFunciona = () => {
  return (
    <section id="como-funciona" className="bg-[#0B1A0B] scroll-mt-24">
      <div className="container-wide py-16 sm:py-24">
        <div className="max-w-3xl mb-8 sm:mb-10">
          <div className="text-[11px] font-semibold tracking-[0.14em] uppercase text-zinc-400">
            Como funciona a aplicação
          </div>
        </div>

        <ol className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-5 lg:gap-6">
          {STEPS.map((s, i) => (
            <li
              key={i}
              className="border-l-2 lg:border-l-0 lg:border-t-2 border-[#4BD084]/40 pl-5 lg:pl-0 lg:pt-5"
            >
              <div className="text-xs font-semibold tracking-[0.14em] text-zinc-400 tabular-nums">
                {s.n}
              </div>
              <div className="mt-2 text-base sm:text-lg font-semibold text-white tracking-tight leading-snug">
                {s.title}
              </div>
              <div className="mt-1.5 text-sm text-zinc-400 leading-relaxed">
                {s.description}
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
};
